import { useState } from "react"

/**
 * Lightweight toast state helper for placeholder actions.
 */
export default function useNotImplementedToast() {
    const [toastMessage, setToastMessage] = useState("")
    const [showToast, setShowToast] = useState(false)
    const [toastType, setToastType] = useState(
        /** @type {"info" | "warning" | "error" | "success"} */ ("warning")
    )
    const [toastTitle, setToastTitle] = useState("Not implemented")
    const [toastAutoDismissMs, setToastAutoDismissMs] = useState(
        /** @type {number | null} */ (2600)
    )
    const [toastVersion, setToastVersion] = useState(0)

    function showNotImplementedToast(message = "This is not implemented yet.") {
        setToastType("warning")
        setToastTitle("Not implemented")
        setToastAutoDismissMs(2600)
        setToastMessage(message)
        setToastVersion((x) => x + 1)
        setShowToast(true)
    }

    function showSuccessToast(message, title = "Success") {
        setToastType("success")
        setToastTitle(title)
        setToastAutoDismissMs(2600)
        setToastMessage(String(message ?? "Done"))
        setToastVersion((x) => x + 1)
        setShowToast(true)
    }

    const toastProps = {
        key: toastVersion,
        show: showToast,
        type: toastType,
        title: toastTitle,
        message: toastMessage,
        autoDismissMs: toastAutoDismissMs,
        onClose: () => {
            setShowToast(false)
            setToastMessage("")
        },
    }

    return { toastProps, showNotImplementedToast, showSuccessToast }
}

